import { gql } from '@apollo/client';

export const ALL_SERVICE_CATEGORIES = gql`
  query AllServiceCategories($input: AllServiceCategoriesInput!) {
    serviceCategories: allServiceCategories(input: $input) {
      id
      name
    }
  }
`;
